<template>
    <div>
        <loading
            id="spinner"
            :active="false"
            :can-cancel="false"
            :is-full-page="true"
        ></loading>

        <group1
            :centers="this.centers"
			:localizacoes="this.localizacoes"
            :editable="this.editable"
            :userprofiles="this.userprofiles"
        />
        <group2 :editable="editable" />
        <group3 :atuacaos="atuacaos" :editable="editable" />
        <grupo-siac />
        <group4 :editable="editable" :maxbolsas="qtdbolsasrestantes" />
    </div>
</template>

<script>
import Group1 from "../groups/Group1.vue";
import Group2 from "../groups/Group2.vue";
import Group3 from "../groups/Group3.vue";
import Group4 from "../groups/Group4.vue";
import GrupoSiac from '../GrupoSiac.vue';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as constantes from "../constantes.js";
import { mapState, mapActions } from "vuex";


export default {
    constants: constantes,
    name: "VueProjetoForm",
    props: {
        projeto: {},
        atuacaos: {
            type: String,
            default: null,
            validator: value => {
                return value ? value : Array;
            }
        },
        centers: {
            type: String,
            default: null,
            validator: value => {
                return value ? value : Array;
            }
        },
		localizacoes: {
            type: String,
            default: null,
            validator: value => {
                return value ? value : Array;
            }
        },
        qtdbolsasrestantes: { type: String, default: 0 },
        editable: { type: String, default: false },
        returnurl: { type: String, default: "/projetos" },
        constantes: { type: String, default: null },
        userprofiles: { type: String, default: null },
        user: {
            type: String,
            default: null,
            validator: value => {
                return value ? value : Array;
            }
        },
        curriculo: {
            type: String,
            default: {},
            validator: value => (value == "[]" ? {} : value)
        }
    },
    components: {
        Loading,
        Group1,
        Group2,
        Group3,
        Group4,
        GrupoSiac
    },
    computed:{
        ...mapState(["project"])
    },
    methods: {
        ...mapActions(["setProject"])
    },
    created() {
        let projeto = JSON.parse(this.$props.projeto);

        if (projeto.id && Number(projeto.id) > 0) {
            this.setProject(JSON.parse(this.$props.projeto));
        } else {
            let user = JSON.parse(this.$props.user);
            let curriculo =
                this.$props.curriculo == "[]"
                    ? {}
                    : JSON.parse(this.$props.curriculo);
            this.$set(this.project, "curriculo", curriculo);
            this.$set(this.project.curriculo, "usuario", user);
            if (user.curriculo) delete this.project.curriculo.usuario.curriculo;
            this.setProject(this.project);
        }
    }
};
</script>
